/* global axios */
import ApiClient from '../ApiClient';

class HistoryWhatsappConsumptions extends ApiClient {
  constructor() {
    super('history_whatsapp_consumptions', { accountScoped: true });
  }

  getAll({ startDate = null, endDate = null, inboxes = [], categories = [], segment = null } = {}) {
    const params = {inboxes_names: inboxes, categories, segment};

    if (startDate && endDate) {
      params.start_date = startDate;
      params.end_date = endDate;
    }

    return axios.get(this.url, { params });
  }

  getSummaryByInbox({ startDate = null, endDate = null, inboxes = [], categories = [] } = {}) {
    const params = {inboxes_names: inboxes, categories};

    if (startDate && endDate) {
      params.start_date = startDate;
      params.end_date = endDate;
    }
    params.summary = true;

    return axios.get(this.url, { params });
  }

  export({ startDate = null, endDate = null, inboxes = [], categories = [], segment = null } = {}) {
    const params = {inboxes_names: inboxes, categories, segment};

    if (startDate && endDate) {
      params.start_date = startDate;
      params.end_date = endDate;
    }

    return axios.get(`${this.url}/export`, { params });
  }
}

export default new HistoryWhatsappConsumptions();
